import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("b", null, "Order:", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "Status:", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Created date:", -1)
const _hoisted_5 = { class: "dialog-footer" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Clear ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Confirm")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "Agency note",
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogVisible) = $event))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_5, [
        (_ctx.userType === 'agency')
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clear()))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.close()))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirm()))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { gutter: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, [
                _hoisted_1,
                _createTextVNode(" " + _toDisplayString(_ctx.requestOrder.orderName), 1)
              ]),
              _createElementVNode("p", null, [
                _hoisted_2,
                _createVNode(_component_el_tag, {
                  type: _ctx.getOrderStatusColor(_ctx.requestOrder.status),
                  size: "small",
                  title: 
              _ctx.requestOrder?.comment ? _ctx.requestOrder.comment : _ctx.requestOrder.status
            
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.requestOrder.status), 1)
                  ]),
                  _: 1
                }, 8, ["type", "title"])
              ]),
              (_ctx.requestOrder?.createdAt)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                    _hoisted_4,
                    _createTextVNode(" " + _toDisplayString(_ctx.formatTime(_ctx.requestOrder?.createdAt)), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_divider),
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                model: _ctx.state,
                "label-width": "120px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "Status:",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.requestOrder.agencyNote,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestOrder.agencyNote) = $event)),
                        autosize: { minRows: 6, maxRows: 10 },
                        type: "textarea",
                        placeholder: "..."
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}